import cn from 'classnames'
import Image from 'next/image'
import {FC} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {theme} from '@/theme/theme'
import {AboutUsStatisticType} from '@/utils/statistics/types'

type StatisticItemProps = AboutUsStatisticType & {
  textVariant?: TextVariant
  isVerticalLayout?: boolean
}

export const StatisticItem: FC<StatisticItemProps> = ({
  title,
  description,
  imageSrc,
  imageAlt,
  textVariant = TextVariant.h5,
  isVerticalLayout = false,
}) => (
  <>
    <div className={cn('item', isVerticalLayout && 'vertical')}>
      {imageSrc && imageAlt && (
        <div className="image-wrapper">
          <Image
            src={imageSrc}
            alt={imageAlt}
            style={{objectFit: 'contain'}}
            width={80}
            height={64}
          />
        </div>
      )}
      <div>
        <Text variant={TextVariant.h2} element="p" className="space-nowrap">
          {title}
        </Text>
        <div className="description">
          <Text
            variant={textVariant}
            element="p"
            color={theme.palette.text.light}
            fontWeight={TextFontWeight.regular}
          >
            {description}
          </Text>
        </div>
      </div>
    </div>

    <style jsx>{`
      .item:not(.vertical) {
        text-align: center;
      }
      .image-wrapper {
        position: relative;
        width: 80px;
        height: 64px;
        flex: 0 0 80px;
        margin: 0 auto ${theme.spacing[4]};
      }
      .description {
        margin-top: ${theme.spacing[2]};
      }
      .vertical {
        display: flex;
        align-items: center;
      }
      .vertical .image-wrapper {
        margin: 0;
        margin-right: ${theme.spacing[4]};
      }
      .vertical .description {
        margin-top: 0;
      }
    `}</style>
  </>
)
